import { BreOrderType } from '~/tenants/bre/model/enums';

const BaseRates = {
  AERIAL_PHOTOS: '150',
  INTRO: '175',
  NARRATION: '250',
  KWASI: '250',
  TWILIGHT: '400',
  AERIAL_UPGRADE: '275'
};

export const BreCinematicRate: Record<BreOrderType, typeof BaseRates> = {
  [BreOrderType.COMMERCIAL]: {
    ...BaseRates,
    AERIAL_UPGRADE: '350',
  },
  [BreOrderType.RENTAL]: BaseRates,
  [BreOrderType.LONG_TERM]: BaseRates,
  [BreOrderType.RESIDENTIAL]: BaseRates,
  [BreOrderType.PROPERTY_MKTG]: BaseRates,
  [BreOrderType.AGENT_MKTG]: BaseRates,
};
